export const Scroll = {
	inserted: function (el) {
		if (el) {
			requestAnimationFrame(() => el.scrollIntoView({ behavior: 'smooth' }))
		}
	}
}